export default function employeeUrl(employee) {
  if (employee.onboardingStatus === 'draft') {
    return `/employees/hire/${employee.id}`;
  }
  return `/employees/${employee.id}`;
}
